<template>
    <div><!-- COA 上傳 -->
        <SearchBar @coaUploadQueryEvent="doCoaUploadSearch" @coaUploadExportEvent="doCoaUploadExport"/>
        <CCard>
            <CCardBody>
                <table class="table ">
                    <thead class="thead-light">
                        <tr>
                            <th class="text-center">{{headers[0]}}</th>
                            <th class="text-center">{{headers[1]}}</th>
                            <th class="text-center">{{headers[2]}}</th>
                            <th class="text-center">{{headers[3]}}</th>
                            <th class="text-center">{{headers[4]}}</th>
                            <th class="text-center">{{headers[5]}}</th>
                            <th class="text-center">{{headers[6]}}</th>
                            <th class="text-center">{{headers[7]}}</th>
                            <th class="text-center">{{headers[8]}}</th>
                        </tr>
                    </thead>
                    <tbody>
                        <tr v-for="(item , index) in coaUploadSearchResult" :key="index">
                            <td class="text-center">{{fixDateTime(item.coaCreateDate)}}</td>
                            <td class="text-center">{{item.customerName}}</td>
                            <td class="text-center">{{item.po}}</td>
                            <td class="text-center">{{item.partnumber}}</td>
                            <td class="text-center">{{item.partname}}</td>
                            <td class="text-center">{{item.coaTotcnt}}</td>
                            <td class="text-center">
                                <div v-html="getCoaFileLink(item)"></div>
                            </td>
                            <td class="text-center">{{item.coaStatusTxt}}</td>
                            <td class="text-center">                                
                                <button class="btn btn-sm btn-danger" @click="deleteRowEvent(item)" v-if="isShowDelBtn(item)">{{i18n('Buttons.Delete')}}</button>
                                <router-link class="btn btn-sm btn-success"  @click.native="editRowEvent(item)" to="">{{editBtnText(item)}}</router-link>
                            </td>
                        </tr>
                    </tbody>
                </table>
            </CCardBody>
        </CCard>
        <!-- <Modal /> -->
    </div>
</template>
<script>
import SearchBar from './SearchBar'
import Modal from './Modal'
import { qualityMixin } from '@/mixin/quality'
import { mapGetters } from 'vuex'
export default {
    mixins: [qualityMixin],	
    components: {
        SearchBar,
        Modal,
    },
    data() {
        return {
            headers :[
                this.i18n("COA.EstablishedDate"),this.i18n("COA.Vendor"),"PO_NO",this.i18n("COA.PartNumber"),this.i18n("COA.Parts"),this.i18n("COA.TotalQuantity"),
                this.i18n("COA.COAUpload"),this.i18n("COA.Status"),this.i18n("COA.Function")
            ],
            coaUploadSearchResult: [],
            queryParam : {}
        }
    },
    props : {
    },
    watch: {
        "lang": function() {
            this.headers = [
                this.i18n("COA.EstablishedDate"),this.i18n("COA.Vendor"),"PO_NO",this.i18n("COA.PartNumber"),this.i18n("COA.Parts"),this.i18n("COA.TotalQuantity"),
                this.i18n("COA.COAUpload"),this.i18n("COA.Status"),this.i18n("COA.Function")
            ]
        }
    },
    methods: {
        doCoaUploadSearch (param){
            const url = `${this.$apiUrl_Quality}/SearchCoaUpload`;
            this.updateLoading(true);
            this.axios.post(url, param).then((response) => {
                const {status , statusMessage} = response.data;
                this.updateLoading(false);
                if(status){
                    this.$alert(statusMessage,'警告',{type: 'warning'});
                }else{                    
                    //--成功                    
                    const rowStatusMap= this.listToMap(this.$t('rowStatusList'), 'rowStatusId' ,'rowStatusCaption');
                    const rows = response.data;
                    rows.forEach(r => {
                        let rowStatusTxt = '';
                        let rowStatus = '';
                        if(r.coaStatus === 0){
                            rowStatus ='A';
                        }else if(r.coaStatus === 1){
                            rowStatus ='B';
                        }else if(r.coaStatus === 2){
                            rowStatus ='C';
                        }
                        if(rowStatus){
                            rowStatusTxt = rowStatusMap[rowStatus];
                        }                        
                        r.coaStatusTxt = rowStatusTxt;
                    });
                    this.coaUploadSearchResult = rows;
                    this.setCacheQueryParam('CoaUpload_QueryParam' , param); 
                    this.queryParam = param;
                }                    
            }); 
        },
        doCoaUploadExport(param){
            const url = `${this.$apiUrl_Quality}/PrepareSearchCoaUploadExport`;
            this.axios.post(url, param).then((response) => {                        
                const respObj = response.data;                 
                const exportExcelToken = respObj.token;
                let urlExcel = `${this.$apiUrl_Quality}/SearchCoaUploadExportExcel/${exportExcelToken}`;
                this.openNewTabByALink('CoaUploadExportExcel',urlExcel);
            })
        },
        isShowDelBtn (item){
            if(item.coaStatus === 2){//退件，才可有刪除
                if(this.isMember){
                    return true;
                }
            } 
            return false;
        },
        editBtnText (item){
            if(item.coaStatus === 0){
                if(!this.isMember){
                    return this.i18n("Buttons.Maintain");
                }                
            }else if(item.coaStatus === 2){
                return this.i18n("Buttons.Maintain");
            }
            return this.i18n("Buttons.DetailInfo");
        },
        getCoaFileLink (item){
            let link= [] ;
            const baseUrl = this.$apiUrl_Quality;
            if(item.coaFile1){
                link.push(`<a class="fileLink" target="_blank" href="${baseUrl}/CoaDownload/1/${item.coaGuid}">檔案1&emsp;</a>`);
            }
            if(item.coaFile2){
                link.push(`<a class="fileLink" target="_blank" href="${baseUrl}/CoaDownload/2/${item.coaGuid}">檔案2&emsp;</a>`);
            }
            if(item.coaFile3){
                link.push(`<a class="fileLink" target="_blank" href="${baseUrl}/CoaDownload/3/${item.coaGuid}">檔案3&emsp;</a>`);
            }
            return link.join('');
        },
        deleteRowEvent (item){ //刪除
            const self =this;
            this.$confirm('此操作將永久刪除該筆資料, 是否繼續?', '提示', {
                confirmButtonText: '確定',
                cancelButtonText: '取消',
                type: 'warning'
            }).then(() => {
                self.doDeleteRow(item.coaGuid);
            });
        },
        doDeleteRow (coaGuid){//呼叫刪除處理
            const url = `${this.$apiUrl_Quality}/DeleteCOAUploadRow`;
            this.updateLoading(true);
            const param = { guid: coaGuid};
            const self =this;
            this.axios.post(url, param).then((response) => {
                const {status , statusMessage} = response.data;
                this.updateLoading(false);
                if(status){
                    this.$alert(statusMessage,'警告',{type: 'warning'});
                }else{                    
                    //--成功
                    self.doCoaUploadSearch(self.queryParam);
                }                    
            }); 
        },
        editRowEvent (item){ //維護 / 詳細資訊            
            sessionStorage.setItem('coaGuid', item.coaGuid);
            this.$router.push('coainformation');
        },
        i18n (keyStr){
            return this.$t(keyStr);
        },
    },
    computed: {
        ...mapGetters(["lang"])
        
    },
	mounted() {
        
	},
    created() {        
    }
}
</script>
<style lang="scss" scoped>
table th:first-child {
    text-align: center;
    padding: 15px 5px;
}

.table tr:nth-child(even) {
    background-color: transparent;
}

.table th {
    background-color: #303c50;
    color: #fff;
}
</style>



